import React from 'react';
import bowser from 'yola-bowser';
import { extensions, view, blocks } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import highlighter from 'src/js/modules/highlighter';
import dividerPosition from 'src/js/modules/control-pane/constants/divider-position';
import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import common from '../constants/common';
import addAndConvertToGroup from '../helpers/add-and-convert-to-group';
import TriggerWithUpgradePopover from '../components/trigger-with-upgrade-popover';

const { Icon } = designSystem;
const { CONVERT_TO_GROUP_TRIGGER_ID } = common;

const addAndConvertToGroupControl = {
  id: CONVERT_TO_GROUP_TRIGGER_ID,
  trigger: (
    <TriggerWithUpgradePopover id={CONVERT_TO_GROUP_TRIGGER_ID}>
      <Icon glyph="plus-for-button" />
    </TriggerWithUpgradePopover>
  ),
  onTriggerClick: (elementId, { getContext }) => {
    const { controlPane } = getContext();

    controlPane.hidePane();
    highlighter.operations.hide([view.accessors.getLiveElement(elementId)]);
    addAndConvertToGroup({ elementId });
  },
  matches(liveElement) {
    if (!bowser.mobile) {
      return false;
    }

    const settings = extensions.accessors.getExtensionSettings(common.slug);
    if (liveElement.matches('ws-media-container') && !liveElement.closest(settings.querySelector)) {
      const closestBlock = getParentBlockByElement(liveElement);
      const blockId = blocks.accessors.getBlockIdByElement(closestBlock);

      return settings.supportedBlockIds.includes(blockId);
    }

    return false;
  },
  priority: 0,
  divider: dividerPosition.LEFT,
};

export default addAndConvertToGroupControl;
